const footerStyle = Object.freeze({
  fontStack: 'alt',
  borderWidth: '1px',
  lines: 2,
  borderStyle: 'solid',
  footerMobileBorderStyle: Object.freeze({
    borderWidth: '1px',
    lines: 2,
    borderStyle: 'solid',
  }),
  footerMobileBottomPadding: '0',
});

export default footerStyle;
